import { LoggerUtil } from 'core/utils/loggerUtil.ts';

export function gtagAnalyticsUtil(sendTo, url, value, currency) {
	const callback = () => {
		if (url) {
			window.location.href = url;
		}
	};

	if (window.gtag) {
		const eventParams = {
			send_to: sendTo,
			event_callback: callback,
		};

		if (value !== undefined) {
			eventParams.value = value;
		}

		if (currency !== undefined) {
			eventParams.currency = currency;
		}
		window.gtag('event', 'conversion', eventParams);
	} else {
		LoggerUtil.logWarning('gtag not found on window object');
	}

	return false;
}
